import React, { useState } from 'react';
import { Card, Space, FormInstance } from 'antd';
import { Param as ParamType, Command } from '../../cliDataSchema';
import { DEFAULT_PARAM_GROUP } from '../../utils/consts';
import Param from './Param';
import ProjectPresetsDropdown from '../presets/ProjectPresetsDropdown';
import ProjectDefaultModal from '../presets/ProjectPresetsModal';

export type FeatureGroupType = { [paramGroup: string]: ParamType[] };

type Props = {
  featureGroup: FeatureGroupType;
  visibleParams: ParamType[];
  form: FormInstance;
  command?: Command;
};

const FeatureGroup: React.FC<Props> = ({
  featureGroup,
  visibleParams,
  form,
  command,
}) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentParamGroup, setCurrentParamGroup] = useState<string | null>(
    null,
  );

  const handleOpenModal = (paramGroup: string) => {
    setCurrentParamGroup(paramGroup);
    setIsModalVisible(true);
  };

  if (!featureGroup) {
    return null;
  }

  return (
    <Space direction="vertical" size="large" style={{ display: 'flex' }}>
      {Object.keys(featureGroup).map((paramGroup) => {
        const params = featureGroup[paramGroup];

        const allowPresets = params.some(
          (param) => param.osep_generator_ui_allow_presets === true,
        );

        if (params.length > 0) {
          if (allowPresets) {
            return (
              <Card
                key={paramGroup}
                title={
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <span>{paramGroup}</span>
                    <div>
                      <ProjectPresetsDropdown
                        form={form}
                        type={
                          params[0]?.osep_generator_ui_param_group as string
                        }
                        onAddDefault={() => handleOpenModal(paramGroup)}
                      />
                    </div>
                  </div>
                }
              >
                {params.map((param) => (
                  <Param
                    key={param.name}
                    param={param}
                    visibleParams={visibleParams}
                    form={form}
                    command={command}
                  />
                ))}
              </Card>
            );
          } else if (paramGroup === DEFAULT_PARAM_GROUP) {
            return params.map((param) => (
              <Param
                key={param.name}
                param={param}
                visibleParams={visibleParams}
                form={form}
                command={command}
              />
            ));
          } else {
            return (
              <Card key={paramGroup} title={paramGroup}>
                <Space
                  direction="vertical"
                  size={'small'}
                  style={{ display: 'flex' }}
                >
                  {params.map((param) => (
                    <Param
                      key={param.name}
                      param={param}
                      visibleParams={visibleParams}
                      form={form}
                      command={command}
                    />
                  ))}
                </Space>
              </Card>
            );
          }
        }
        return null;
      })}

      <ProjectDefaultModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        currentParamGroup={currentParamGroup}
        setCurrentParamGroup={setCurrentParamGroup}
        featureGroup={featureGroup}
        formInput={form}
      />
    </Space>
  );
};

export default FeatureGroup;
